/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ConvoDefs from './defs.defs'

const $nsid = 'chat.bsky.convo.removeReaction'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  value: /*#__PURE__*/ l.string({
    maxLength: 64,
    minLength: 1,
    maxGraphemes: 1,
    minGraphemes: 1,
  }),
  convoId: /*#__PURE__*/ l.string(),
  messageId: /*#__PURE__*/ l.string(),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  message: /*#__PURE__*/ l.ref<ConvoDefs.MessageView>(
    (() => ConvoDefs.messageView) as any,
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Removes an emoji reaction from a message. Requires authentication. It is idempotent, so multiple calls from the same user with the same emoji result in that reaction not being present, even if it already wasn't. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'InvalidConvo',
  'ReactionNotAllowed',
  'ReactionMessageDeleted',
  'ReactionInvalidValue',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
